import * as React from "react";
import { Layout } from "../common/Layout";
import { SectionContainer } from "../common/SectionContainer";
import { Grid, Paper } from "@mui/material";
import { BlogMetaColumn } from "./template/meta/BlogMetaColumn";
import { SectionTitle } from "../common/SectionTitle";

export interface IBlogLayoutProps {
  title: string;
  children: React.ReactNode;
  noPaper?: boolean;
  sectionTitle?: string;
}

export function BlogLayout(props: IBlogLayoutProps) {
  return (
    <Layout includeFooter includeHeader includeSocials title={props.title}>
      <SectionContainer vPadding="120px">
        {props.sectionTitle && (
          <SectionTitle
            title={props.sectionTitle}
            gutterBottom
            centre
            hideTag
          />
        )}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            {!props.noPaper ? (
              <Paper
                sx={{
                  padding: "32px",
                }}
                elevation={0}
              >
                {props.children}
              </Paper>
            ) : (
              props.children
            )}
          </Grid>
          <Grid item xs={12} sm={4}>
            <BlogMetaColumn />
          </Grid>
        </Grid>
      </SectionContainer>
    </Layout>
  );
}
